import _ from 'lodash';
import { useCallback, useEffect } from 'react';
import app from '~/app';
import { log, jwt_decode } from '@swiper/core';
// import Promise from 'bluebird';

export function useAuthHandler( state, dispatch ) {

  const authenticate = useCallback( ( opts ) => {
    log.debug( 'AUTHENTICATING', opts );
    return app.authenticate( opts ).then( ( { accessToken } ) => {
      const token = jwt_decode( accessToken );
      log.debug( 'AUTH TOKEN', token );
      /*
      return Promise.map( [ 'member', 'station' ], type => {
        const id = token[ `${type}Id` ];
        if ( ! id ) return;
        const service = `/api/${type}s`;
        return app.service( service )
          .get( id ).then( res => {
            log.debug( `Got auth subject "${type}":`, res );
            return dispatch[ type ]( res );
          } );
      } );
      */
      return token;
    } );
  }, [] );

  const handleAuthenticated = useCallback( ( authResult ) => {
    dispatch( { login : jwt_decode( authResult.accessToken ) } );
  }, [ dispatch ] );
  const handleLogout = useCallback( () => {
    dispatch( { login : null } );
  }, [ dispatch ] );
  const handleReauthError = useCallback( ( err ) => {
    log.error( `Re-authentication failure`, err );
    dispatch( {
      login : null,
      error : 'Re-authentication failure',
    } );
  }, [ dispatch ] );

  useEffect( () => {
    app.on( 'authenticated', handleAuthenticated );
    app.on( 'logout', handleLogout );
    app.on( 'reauthentication-error', handleReauthError );

    return () => {
      app.off( 'authenticated', handleAuthenticated );
      app.off( 'logout', handleLogout );
      app.off( 'reauthentication-error', handleReauthError );
    };
  }, [ handleAuthenticated, handleLogout, handleReauthError ] );

  return { authenticate };
}
